import { useRoboBallExpression } from "@/components/figutour/RoboBallExpressionContext";

/**
 * SVG overlay for the Robo-Ball's eyes (Phase 19c/d refactor).
 *
 * Two states:
 *   • `idle`  — symmetric neon-blue LED circles with a 4.5 s blink keyframe
 *               (`.roboball-eye-blink` uses the new `roboBlink` keyframe
 *                which drops from `scaleY(1)` to `scaleY(0.08)` briefly
 *                every cycle, avoiding any downward eye "sag").
 *   • `smile` — two upward Q-curve arcs (paused blink, transitions smoothly)
 *
 * Pointer-events: none — never intercepts drag / click on the FAB.
 *
 * Regression vs the pre-Phase-19c rendering: the idle eyes were
 * `<ellipse rx="3.5" ry="4">` — the vertical stretch produced a slight
 * downward-droop illusion when composited on the ball. Replaced with
 * symmetric `<circle r="3.5">` per Phase 19c/d G1. See PRD for the
 * before/after path values.
 */
export default function EyeExpression() {
  const { state } = useRoboBallExpression();
  const smiling = state === "smile";

  return (
    <svg
      viewBox="0 0 40 20"
      preserveAspectRatio="xMidYMid meet"
      className="roboball-eye-overlay"
      aria-hidden="true"
      focusable="false"
      data-testid="roboball-eyes"
      data-eye-state={state}
      style={{
        position: "absolute",
        top: "30%",
        left: "50%",
        transform: "translateX(-50%)",
        width: "60%",
        height: "20%",
        pointerEvents: "none",
        transition: "opacity 300ms ease",
      }}
    >
      {smiling ? (
        <>
          <path
            d="M 4 14 Q 10 4 16 14"
            fill="none"
            stroke="#38bdf8"
            strokeWidth="2.5"
            strokeLinecap="round"
            className="roboball-eye-smile"
          />
          <path
            d="M 24 14 Q 30 4 36 14"
            fill="none"
            stroke="#38bdf8"
            strokeWidth="2.5"
            strokeLinecap="round"
            className="roboball-eye-smile"
          />
        </>
      ) : (
        <>
          {/* Phase 19c/d — symmetric LED circles (no vertical stretch). */}
          <circle
            cx="10"
            cy="10"
            r="3.5"
            fill="#38bdf8"
            stroke="#ffffff"
            strokeWidth="0.6"
            className="roboball-eye-blink"
          />
          <circle
            cx="30"
            cy="10"
            r="3.5"
            fill="#38bdf8"
            stroke="#ffffff"
            strokeWidth="0.6"
            className="roboball-eye-blink"
          />
        </>
      )}
    </svg>
  );
}
